import { useState, useRef, useEffect } from 'react'
import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'
import hylkyservices from '../services/hylkykortti'
import { notify, alert } from '../utils/toaster'
import ReCAPTCHA from 'react-google-recaptcha'
import config from '../config'
import '../App.css'

const getRecaptchaToken = () => {
  return config.RECAPTCHA_KEY
}

const NewCommentForm = ({ pageId, setIsOpen }) => {
  const [formData, setFormData] = useState({ name: '', email: '', comment: '' })
  const recaptchaTokenRef = useRef()

  useEffect(() => {
    Object.keys(formData).forEach((key) => {
      setFormData((prev) => ({ ...prev, [key]: window.localStorage.getItem(key) }))
    })
  }, [])

  const clearLocalStorage = () => {
    Object.keys(formData).forEach((key) => {
      window.localStorage.removeItem(key)
    })
  }

  const handleSubmit = async (event) => {
    event.preventDefault()
    const token = await recaptchaTokenRef.current.getValue()
    if (!token) {
      alert('Vahvista, että olet ihminen klikkaamalla "En ole robotti" -ruutua!')
      return
    }

    const commentData = {
      post: pageId,
      author_name: formData.name,
      author_email: formData.email,
      åäåööäåä: formData.comment,
      content: 'vakioveikkaus',
      captcha_token: token,
    }
    try {
      await hylkyservices.postComment(commentData)
      setFormData({ name: '', email: '', comment: '' })
      clearLocalStorage()
      setIsOpen(false)
      notify('Kommentti on vastaanotettu ja se odottaa tarkastusta.')
      recaptchaTokenRef.current = null
    } catch (error) {
      alert('Virhe kommentin lähetyksessä, yritä myöhemmin uudelleen.')
      recaptchaTokenRef.current.reset()
    }
  }

  const handleChange = (event) => {
    setFormData({ ...formData, [event.target.name]: event.target.value })
    window.localStorage.setItem(event.target.name, event.target.value)
  }

  const handleCancel = () => {
    clearLocalStorage()
    setIsOpen(false)
  }

  return (
    <Form onSubmit={handleSubmit} className="styleForm mb-3">
      <h2>Uusi kommentti</h2>
      <Form.Group className="container mt-2" controlId="formUsername">
        <Form.Label>Nimi</Form.Label>
        <Form.Control required type="string" name="name" value={formData.name} onChange={handleChange} />
        <Form.Text className="text-muted">Nimi näkyy julkisesti kommenttisi yhteydessä.</Form.Text>
      </Form.Group>
      <Form.Group className="container mt-2" controlId="formEmail">
        <Form.Label>Sähköposti</Form.Label>
        <Form.Control required type="email" name="email" value={formData.email} onChange={handleChange} />
        <Form.Text className="text-muted">Sähköpostiosoitetta ei näytetä julkisesti.</Form.Text>
      </Form.Group>
      <Form.Group className="container mt-2" controlId="formComment">
        <Form.Label>Kommentti</Form.Label>
        <Form.Control
          required
          as="textarea"
          rows="5"
          placeholder="Jaa oma tarinasti tästä hylystä muiden kanssa..."
          name="comment"
          value={formData.comment}
          onChange={handleChange}
        />
      </Form.Group>
      <Form.Group>
        <ReCAPTCHA
          ref={recaptchaTokenRef}
          className="container mt-2"
          sitekey={getRecaptchaToken()}
          /* onChange={handleRecaptchaChange} */
        />
      </Form.Group>
      <Button className="ms-2 mt-3 mb-1" variant="primary" type="submit">
        Lähetä kommentti
      </Button>
      <Button className="float-end mt-3 me-2 mb-1" variant="danger" onClick={handleCancel}>
        Peruuta
      </Button>
    </Form>
  )
}

export default NewCommentForm
